// extracted by mini-css-extract-plugin
module.exports = {"cardBlockSummary":"RewardsSummaryModule__cardBlockSummary__76+aV"};